exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._1IRWCVIOsdYonOtoxHxdR7,html[dir] ._2ybx4__AcBXOdtExubUkCD,html[dir] ._3iaW3DAkIu9mBLhB4bJjOy{text-align:center}._1IRWCVIOsdYonOtoxHxdR7{font-size:17px;font-weight:300;color:\"[theme:neutralPrimary, default:#333333]\"}html[dir] ._1IRWCVIOsdYonOtoxHxdR7{padding-top:36px}._1yzudGPIM95NWkd2VMt9oj{width:120px;height:120px}._2ybx4__AcBXOdtExubUkCD{font-size:12px;font-weight:400;color:\"[theme:neutralSecondary, default:#666666]\"}html[dir] ._2ybx4__AcBXOdtExubUkCD{padding-top:10px}._3-vVk4ZGxRTHbM5t2cFgWM{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
exports.locals = {
	"messageText": "_3iaW3DAkIu9mBLhB4bJjOy",
	"mainMessageText": "_1IRWCVIOsdYonOtoxHxdR7",
	"detailsMessageText": "_2ybx4__AcBXOdtExubUkCD",
	"icon": "_1yzudGPIM95NWkd2VMt9oj",
	"emptyStateContainer": "_3-vVk4ZGxRTHbM5t2cFgWM"
};